function isLocalStorageAvailable(): boolean {
    try {
        const key = '__storage_test__';
        localStorage.setItem(key, key);
        localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
}

const available = isLocalStorageAvailable();

export const safeLocalStorage = {
    getItem(key: string): string | null {
        if (!available) return null;
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem(key: string, value: string): void {
        if (!available) return;
        try {
            localStorage.setItem(key, value);
        } catch {
            // storage full or unavailable
        }
    },
    removeItem(key: string): void {
        if (!available) return;
        try {
            localStorage.removeItem(key);
        } catch {
            // unavailable
        }
    },
};
